var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "document-uploader" },
    [
      _vm.mode == "upload"
        ? _c(
            "div",
            [
              _c("div", { staticClass: "upload-text-detail" }, [
                _vm._v("Upload a document")
              ]),
              _vm._v(" "),
              _c("documentUploader", {
                ref: "documentUploader",
                attrs: {
                  "secure-upload-token": _vm.secureToken,
                  "user-token": _vm.userToken,
                  isMobile: _vm.isMobile
                },
                on: {
                  uploadStarted: _vm.uploadStarted,
                  uploadSuccess: _vm.uploadSuccess,
                  uploadFailure: _vm.uploadFailure,
                  filesToUpload: _vm.getFilesForUpload
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "button-main" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "upload-basic-btn cancel-btn",
                      attrs: {
                        width: "150px",
                        height: "48px",
                        color: "#ffffff"
                      },
                      on: { click: _vm.goBack }
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "upload-basic-btn upload-btn",
                      attrs: {
                        width: "150px",
                        height: "48px",
                        color: "#128279",
                        disabled:
                          _vm.uploadInProgress || !_vm.filesToUpload.length
                      },
                      on: {
                        click: function($event) {
                          return _vm.startingUpload()
                        }
                      }
                    },
                    [_vm._v("\n        Upload\n      ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.snackbar
        ? _c(
            "v-snackbar",
            {
              attrs: { color: "#EAF4ED", elevation: "50", timeout: 5000 },
              scopedSlots: _vm._u(
                [
                  {
                    key: "action",
                    fn: function(ref) {
                      var attrs = ref.attrs
                      return [
                        _vm.showSnackBtn
                          ? _c(
                              "v-btn",
                              _vm._b(
                                {
                                  attrs: { color: "#32984D" },
                                  on: { click: _vm.handleDocsBtn }
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              [_vm._v("\n        Go to Documents\n      ")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ],
                null,
                false,
                2416259970
              ),
              model: {
                value: _vm.snackbar,
                callback: function($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar"
              }
            },
            [
              _c("i", {
                staticClass: "fa-solid fa-circle-check",
                staticStyle: {
                  color: "#32984d",
                  "font-size": "18px",
                  "margin-right": "20px"
                }
              }),
              _vm._v("\n    Document(s) uploaded successfully\n    ")
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("SnackBar", {
        attrs: {
          id: "error-snack-bar",
          snackbar: _vm.isFail,
          snackbarMsg: "Unsupported file format or corrupted",
          iconName: "fa-regular fa-xmark",
          isSuccess: !_vm.isFail
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }